import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Space, Row, Col, Form, Input , Button, Popconfirm, Select } from 'antd';
import { DatePicker } from 'components/atoms'
import {  usePaymentRequestDetail } from 'hooks';
import moment, { Moment } from 'moment';
import { dateFormat } from 'utils/date-utils';
import { IMaskInput } from "react-imask";

export interface PaymentModalProps extends PopupProps {
    id: number;
    group: string;
}

const PaymentRequestModal = ({ isOpen, onClose, id, group }: PaymentModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */  
  const [paymentItem, setPaymentItem] = useState<PaymentRequestItemDto>();
  const [payments, setPayments] = useState<PaymentRequestItemDto[]>();
  const [selectValue, setSelectValue] = useState<number>();

   /* ======================================================
   * variables
   * ====================================================== */
   const [form] = Form.useForm();
   const { TextArea } = Input;

   /* ======================================================
   * events
   * ====================================================== */
   
  const onCloseCancle = () => {
    onClose?.(insertSuccess); 
  }  

  const onInsert = () => {

    if (!!paymentItem) {
      const data = {
        schedule_group: group,
        schedule_srl: paymentItem.value,
        payment_title: paymentItem.label,
        payment_price: form.getFieldValue("payment_price").toString().replaceAll(',',''), 
        payment_day: form.getFieldValue("payment_day") ? dateFormat(form.getFieldValue("payment_day"), 'YYYY-MM-DD'):'null',
        memo: form.getFieldValue("memo"),
      }
      paymentInsert(data) 
    }
  }

  /* ======================================================
   * hooks
   * ====================================================== */
  const { isLoading, paymentList, paymentInsert, insertSuccess } = usePaymentRequestDetail(id, group);   

  /* ======================================================
   * effects
   * ====================================================== */

  useEffect(() => {
    if (!!paymentList && paymentList.length > 0) {
      setPaymentItem(paymentList[0]);
      setSelectValue(paymentList[0].value);
      setPayments(paymentList);
    }
  }, [paymentList])

  useEffect(() => {
    if (!!paymentItem) {
      form.setFieldsValue({
        payment_price: paymentItem.payment_price,
        payment_day: moment(),
      });     
    }     
  }, [paymentItem])

  useEffect(() => {
    if (insertSuccess && !!paymentItem) {
      const newList = paymentList?.filter((item) => item.value !== paymentItem.value)
      if (!!newList && newList.length > 0) {
        setPaymentItem(newList[0]);
        setSelectValue(newList[0].value);        
        setPayments(newList);
      } else {
        onClose?.(true);
      }
    }     
  }, [insertSuccess])  

    return (
        <ModalWrapper open={isOpen} onCancel={onCloseCancle} width={650} title={'강사료 지급 요청서'} closable>
            <Space direction="vertical" style={{ width: '100%' }}>
            <Form
                    form={form}
                    name="RefCode"
                    layout="horizontal"  
                    labelCol={{ flex: '100px' }}
                    style={{width:'100%'}}                 
                >                                        
                    <Form.Item label={'지급항목 선택'}>
                        <Select 
                          options={payments} 
                          value={selectValue}
                          onSelect={(value, option) => {
                            setPaymentItem(option);
                            setSelectValue(value);
                          }}
                        />               
                    </Form.Item>   
                    <Form.Item label={'강사명'}>
                        <label>{paymentItem?.lecturer_name}</label>                  
                    </Form.Item>                    
                    <Row>
                      <Col span={12}>
                          <Form.Item label={'시간당 단가'} >
                            <label>{paymentItem?.lecturer_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</label>
                          </Form.Item>  
                      </Col> 
                      <Col span={12}> 
                          <Form.Item label={'소득형태'}>
                            <label>{paymentItem?.lecturer_income_type}</label>
                          </Form.Item>   
                      </Col>            
                  </Row> 
                    <Form.Item label={'강사메모'}>
                        <pre style={{display: "inline"}}>{paymentItem?.lecturer_memo}</pre>                  
                    </Form.Item>   
                    <Form.Item name="payment_price" label={'지급금액'}>
                    <IMaskInput 
                      min={0} 
                      mask = {Number}
                      thousandsSeparator={','}
                      className={'ant-input'} 
                      unmask={'typed'} 
                      onAccept = {((value, mask) => form.setFieldValue('payment_price', value))}/>                         
                    </Form.Item>                     
                    <Form.Item name="payment_day" label={'지급일'}>
                      <DatePicker showTime={false} format="YYYY-MM-DD" disabled/>      
                    </Form.Item>    
                    <Form.Item name='memo' label={'메모'}>
                        <TextArea rows={2} placeholder='메모를 입력하세요'/>   
                    </Form.Item>                                                             
                </Form> 
                <ButtonGroup className={'buttonsWrapper'}>
                  <Button onClick={()=>{onClose?.(false)}}>닫기</Button>
                  <Space>
                    <Popconfirm
                        title="외주 강사비 지급 신청 하시겠습니까?"
                        okText="신청"
                        cancelText="취소"
                        onConfirm={onInsert}
                    >   
                        <Button type="primary">신청</Button>
                    </Popconfirm> 
                  </Space>
                </ButtonGroup>  
            </Space>     
        </ModalWrapper>  
    )    
};

export default React.memo(PaymentRequestModal);    